import { memo } from 'react'

const AddPaymentCardDialogError = ({
    error,
    setError,
    handleModal,
}) => {
    
    return (
        
        <div>
            
            <p className="mb-4">
                {error}
            </p>
            
            <div className="mb-2 modal-footer flex justify-end">
                <button
                    type="button"
                    className="mr-3 btn btn-primary btn-outline"
                    onClick={() => handleModal()}>
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={() => setError()}>
                    Try Again
                </button>
            </div>
        
        </div>
        
    )
    
}

export default memo(AddPaymentCardDialogError)
